import axios from 'axios';
import router from '../router'
import store from '../store';

export default function setup() {

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (401 === error.response.status) {
        store.commit('logout');
        /**
         * Do no direct to /user-login if it is already the current route. 
         * This can occur since the landing page makes multiple API calls that can 
         * all return 401.
         */
        if (router.currentRoute.path !== '/user-login') {
          router.push({
            path: '/user-login',
            query: { message: 'inactive' }, // Alert login view of inactivity logout. 
          });
        }
        return error;
      } else if (403 === error.response.status) {
        /**
         * IMPORTANT - 403 indicates the user doesn't have permission. 
         * In some error handling in the app, the error message below is checked for and used to 
         * replace the default global error handler message to give the user a better idea of the problem, 
         * for example they will know to request the required permission. 
         */
        return Promise.reject(new Error("You do not have permission to perform this activity. Please contact your system administrator."))
      } else {
        /**
         * TODO Should not return the error as it is logged here already. 
         * The specific error should only be logged here. Axios catch blocks
         * will need to be tested when this error is not returned. 
         */
        return Promise.reject(error)
      }
    });
}